// src/features/patients/hooks/useSearch.js

import { useCallback, useState } from "react";
import { dbDateFormat } from "../classes/utils/DateUtils";

export const useSearch = onSearch => {
  const [searchCriteria, setSearchCriteria] = useState({});

  const handleSearchChange = useCallback(e => {
    const { name, value } = e.target;

    setSearchCriteria(prevFields => {
      const updatedFields = { ...prevFields };

      if (value !== "") {
        // Handle nested fields like 'address.street'
        if (name.includes(".")) {
          const [parent, child] = name.split(".");

          // Ensure parent object exists
          updatedFields[parent] = {
            ...(updatedFields[parent] || {}),
            [child]: value,
          };
        } else {
          // Handle regular fields
          updatedFields[name] = value;
        }
      } else {
        // Handle field clearing
        if (name.includes(".")) {
          const [parent, child] = name.split(".");

          // Only attempt to delete if parent exists
          if (updatedFields[parent]) {
            const parentObj = { ...updatedFields[parent] };
            delete parentObj[child];

            // Remove parent if empty
            if (Object.keys(parentObj).length === 0) {
              delete updatedFields[parent];
            } else {
              updatedFields[parent] = parentObj;
            }
          }
        } else {
          // Remove regular fields
          delete updatedFields[name];
        }
      }

      return updatedFields;
    });
  }, []);

  const handleDateChangeInSearch = useCallback(timestamp => {
    setSearchCriteria(prevFields => {
      const updatedFields = { ...prevFields };
      if (timestamp && timestamp !== "0") {
        updatedFields.birthday = dbDateFormat(timestamp);
      } else {
        delete updatedFields.birthday;
      }
      return updatedFields;
    });
  }, []);

  const clearAllFilters = useCallback(() => {
    setSearchCriteria({});

    // Ensure parent component is notified of empty criteria
    if (onSearch) {
      onSearch({});
    }
  }, [onSearch]);

  return {
    searchCriteria,
    handleSearchChange,
    handleDateChangeInSearch,
    clearAllFilters,
  };
};
